import { createAsyncThunk } from "@reduxjs/toolkit";
import { parseApiError } from "../../utils/api_error";
import { getCurrentUser } from "../../services/auth";

export const currentUser = createAsyncThunk(
  "auth/getCurrentUser",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const res = await getCurrentUser();
      return res;
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);
